import React from 'react';
import Modal from './Modal';
import './ShortcutsModal.css';

const Shortcut = ({ action, keys }) => (
    <div className="shortcut-row">
        <span>{action}</span>
        <div className="shortcut-keys">
            {keys.map((key, index) => (
                <span key={index} className="shortcut-key">{key}</span>
            ))}
        </div>
    </div>
);

const shortcuts = {
    "General": [
        { action: 'Create new item', keys: ['N'] },
        { action: 'Close modals', keys: ['Esc'] },
        { action: 'Add', keys: ['A'] },
        { action: 'Export', keys: ['E'] },
        { action: 'Email', keys: ['M'] },
    ],
    "Panel Builder": [
        { action: 'Export Panels', keys: ['E'] },
        { action: 'Label Selected Port', keys: ['L'] },
        { action: 'Delete Selected', keys: ['Del', 'Backspace'] },
    ],
    "Roster": [
        { action: 'Add new member', keys: ['N'] },
        { action: 'Email Roster', keys: ['M'] },
        { action: 'Focus Search', keys: ['S'] },
    ],
    "Schedule": [
        { action: 'New shift', keys: ['N'] },
    ],
    "Hours Tracker": [
        { action: 'Open Settings modal', keys: ['S'] },
    ],
    "VLAN": [
        { action: 'Export Script', keys: ['E'] },
    ],
    "IP Manager": [
        { action: 'New IP entry', keys: ['N'] },
        { action: 'Search', keys: ['/'] },
        { action: 'Export CSV', keys: ['E'] },
    ],
    "Wire Diagram": [
        { action: 'New page', keys: ['N'] },
        { action: 'Find device', keys: ['S'] },
        { action: 'Export PDF', keys: ['E'] },
        { action: 'Fit to screen', keys: ['F'] },
        { action: 'Zoom 100% / in / out', keys: ['0', '+', '-'] },
        { action: 'Undo / Redo', keys: ['Ctrl+Z', 'Ctrl+Shift+Z'] },
        { action: 'Remove selected', keys: ['Del', 'Backspace'] },
        { action: 'Pan canvas', keys: ['Space+Drag'] },
    ]
};

const ShortcutsModal = ({ isOpen, onClose }) => {
    // Added Panel Builder to the first column
    const firstColumnKeys = ["General", "Hours Tracker", "Panel Builder"];
    
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Keyboard Shortcuts">
            <div className="shortcuts-container">
                <div className="shortcuts-column">
                    {firstColumnKeys.map(key => (
                        <div key={key} className="shortcut-section">
                            <h3>{key}</h3>
                            {shortcuts[key].map((shortcut, index) => (
                                <Shortcut key={index} action={shortcut.action} keys={shortcut.keys} />
                            ))}
                        </div>
                    ))}
                </div>
                <div className="shortcuts-column">
                    {Object.keys(shortcuts).filter(key => !firstColumnKeys.includes(key)).map(key => (
                         <div key={key} className="shortcut-section">
                            <h3>{key}</h3>
                            {shortcuts[key].map((shortcut, index) => (
                                <Shortcut key={index} action={shortcut.action} keys={shortcut.keys} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default ShortcutsModal;